import React from 'react';
import { useIntl } from 'react-intl';
import { styled } from '@linaria/react';
import { Box } from '@vio/atlas/helpers/Box';
import { filterMessages } from 'components/Filters/filterMessages';
import { FacetType } from 'types/Search';
import { getFacetsSortedAlphabetically } from 'utils/facilities';
import { FacetFilterProps } from '../FacetFilter';
import { FacetFilterList } from '../FacetFilterList/FacetFilterList';
const PopularWrapper = /*#__PURE__*/styled('div')({
  name: "PopularWrapper",
  class: "p1c2k1jb",
  propsAsIs: false
});
interface FacetsRenderListProps extends FacetFilterProps {
  popularIsVisible: boolean;
  popularFacets: FacetType[];
  validFacets: FacetType[];
}
export const FacetsRenderList: React.FC<FacetsRenderListProps> = ({
  popularIsVisible,
  popularFacets,
  validFacets,
  searchParamName,
  getLabel,
  onChange,
  columns,
  filters,
  limit,
  contractedMessage,
  showMoreRenderType
}) => {
  const {
    formatMessage
  } = useIntl();
  return <Box width="100%">
      {popularIsVisible && <PopularWrapper>
          <FacetFilterList title={formatMessage(filterMessages.popularTypes)} facets={popularFacets} filters={filters} searchParamName={searchParamName} getLabel={getLabel} onChange={onChange} columns={columns} showMoreRenderType={showMoreRenderType} />
        </PopularWrapper>}
      <FacetFilterList title={popularIsVisible && formatMessage(filterMessages.allTypes)} facets={getFacetsSortedAlphabetically(validFacets, getLabel as (T: string) => string)} filters={filters} searchParamName={searchParamName} getLabel={getLabel} columns={columns} limit={limit} contractedMessage={contractedMessage} onChange={onChange} showMoreRenderType={showMoreRenderType} />
    </Box>;
};

require("./FacetsRenderList.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./FacetsRenderList.tsx");